import { ROUTE_AUDIT } from '../../../routing/paths';
import { AuditType } from '../../../services/apiFlowService';
import { redirectToB2CThermique } from '../../../routing/homeRouting';

export type CreationCard = {
    auditType: AuditType;
    title: string;
    url?: string;
    icon: string;
    navigate?: () => void;
};

export const creationCards: CreationCard[] = [
    {
        auditType: 'Expert',
        title: 'Audit mode expert',
        url: ROUTE_AUDIT,
        icon: 'icon-study',
    },
    {
        auditType: 'Thermique',
        title: 'Etude thermique',
        icon: 'icon-mail',
        navigate: () => {
            // ajoute une tempo de 5 secondes avant de rediriger
            redirectToB2CThermique();
        },
    },
];
